module.exports = __webpack_public_path__ + "static/media/filterIcon.79656106.svg";